export const countryFlags: Record<string, string> = {
  BH: '🇧🇭',
  AE: '🇦🇪',
  SA: '🇸🇦',
  QA: '🇶🇦',
  KW: '🇰🇼',
  OM: '🇴🇲',
};

export function getCountryFlag(code: string): string {
  return countryFlags[code] || '🏳️';
}

type FlagSize = 'sm' | 'md' | 'lg' | 'xl';

const flagSizes: Record<FlagSize, number> = {
  sm: 40,
  md: 80,
  lg: 160,
  xl: 320,
};

export function getFlagImageUrl(code: string, size: FlagSize = 'md'): string {
  const width = flagSizes[size];
  return `https://flagcdn.com/w${width}/${code.toLowerCase()}.png`;
}
